module.exports = __webpack_public_path__ + "static/media/ecobee-thermostat.7bdd2dcd.webp";